export default "__VITE_ASSET__4K_8qyUG__"